export const API_BASE_HOST = "https://api.artest.net";
export function extractAElemParams(elem, params = {}) {
    let params_arr = elem.search.substring(1).split("&").map(v => v.split("=", 2)).filter(v => v[0]);
    for (let i in params_arr) {
        let [key, value] = params_arr[i];
        params[key] = value;
    }
    return params;
}
export function cleanAElemPathParams(elem, params = {}) {
    params = extractAElemParams(elem, params);
    let params_arr = Object.keys(params).map(key => key + "=" + params[key]);
    return `${elem.pathname}?${params_arr.join("&")}`;
}
export function API_GET(path, params, callback) {
    if (typeof params === "function") {
        callback = params;
        params = {};
    }
    params = params || {};
    callback = callback || (() => { });
    let elem = document.createElement("a");
    if (path[0] == "/")
        path = path.substring(1);
    elem.href = `${API_BASE_HOST}/v2/${path}`;
    path = cleanAElemPathParams(elem, params);
    let requestUrl = `${API_BASE_HOST}${path}`;
    let xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status >= 200 && this.status < 300) {
            let response = this.responseText;
            try {
                response = JSON.parse(response);
            }
            catch (error) {
                console.error(error);
            }
            callback(null, response, this);
        }
    };
    xhttp.onerror = (error) => callback(error);
    xhttp.open("GET", requestUrl, true);
    xhttp.send();
}
